/**
 * Created by Todd Yu on 05/20/2020.
 * Description:
 * Admin Page Module
 * ------ maintenance history ------
 * modified by Teddy Ding on 12/15/20
 * modified by Lucas Wang on 08/19/20
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

import { EffectsModule } from '@ngrx/effects';

import { AaclKeywordSearchModule } from 'aacl-keyword-search';
import { AaclIconModule, AaclIconModuleOptions } from 'aacl-icon';

import { AdminPageNoteTypeEffects } from '../../redux/effects/admin-page-effects/note-type.effects';
import { AdminPageEntityTypeEffects } from '../../redux/effects/admin-page-effects/entity-type.effects';
import { AdminPageUsersEffects } from '../../redux/effects/admin-page-effects/users.effects';
import { AdminPageFilter } from '../../tamalelibs/pipes/admin-page.pipe';
import { ContactListFilter } from '../../tamalelibs/pipes/contact-list.pipe';
import { UserListFilter } from '../../tamalelibs/pipes/user-list.pipe';
import { AdminPageRoutingModule } from './admin-page-routing.module';
import { PopupModule } from '@progress/kendo-angular-popup';
import { AdminPageLayoutComponent } from './admin-page-layout/admin-page-layout.component';
import { AdminGridPageComponent } from './admin-page-content/admin-grid-page/admin-grid-page.component';
import { AdminPageWidgetComponent } from './admin-page-content/admin-page-widget/admin-page-widget.component';
import { AdminIntralinksComponent } from './admin-page-content/admin-intralinks/admin-intralinks.component';
import { WidgetsModule } from '../../widgets/widgets.module';
import { AdminPageActionsComponent } from './admin-page-actions/admin-page-actions.component';
import { AdminAutoTagPageComponent } from './admin-page-content/admin-autotag-page/admin-autotag-page.component';
import { UsersEditorComponent } from './admin-page-content/admin-page-editors/users-editor/users-editor.component';
import { NoteTypesEditorComponent } from './admin-page-content/admin-page-editors/note-types-editor/note-types-editor.component';
import { EntityTypesEditorComponent } from './admin-page-content/admin-page-editors/entity-types-editor/entity-types-editor.component';
import { AdminExchangeServerComponent } from './admin-page-content/admin-exchange-server/admin-exchange-server.component';
import { AdminGoogleMapServiceComponent } from './admin-page-content/admin-google-map-service/admin-google-map-service.component';
import { AdminWorkflowPageComponent } from './admin-page-content/admin-workflow-page/admin-workflow-page.component';
import { AdminTemplateSettingsComponent } from './admin-page-content/admin-template-settings/admin-template-settings.component';
import { AdminTemplateEditButtonComponent } from './admin-page-content/admin-template-settings/admin-template-edit-button.component';
import { MdlDialogModule } from '../mdl-dialog/mdl-dialog.module';
import { AdminGeneralComponent } from './admin-page-content/admin-general/admin-general.component';
import { AdminPageGeneralEffects } from '../../redux/effects/admin-page-effects/general.effect';
import { AdminEmailSettingComponent } from './admin-page-content/admin-email-setting/admin-email-setting.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { AdminRelationshipsComponent } from './admin-page-content/admin-relationships/admin-relationships.component';
import { RelationshipsTypesEditorComponent } from './admin-page-content/admin-page-editors/relationships-types-editor/relationships-types-editor.component';
import { AdminNotificationsComponent } from './admin-page-content/admin-notifications/admin-notifications.component';
import { AdminNotificationActionsComponent } from './admin-page-content/admin-notifications/admin-notification-actions.componment';
import { AdminNotificationActiveComponent } from './admin-page-content/admin-notifications/admin-notification-active.component';
import { AdminNotificationActionService } from './admin-page-content/admin-notifications/admin-notification.service';
import { NotificationEditorComponent } from './admin-page-content/admin-page-editors/notification-editor/notification-editor.component';
import { EditRelationshipDialogComponent } from '../edit-relationship-dialog/edit-relationship-dialog.component';
import { EditRelationshipService } from '../edit-relationship-dialog/edit-relationship-dialog.service';
import { AdminPortfolioUploadComponent } from './admin-page-content/admin-portfolio-upload/admin-portfolio-upload.component';
import { PortfolioUploadEditorComponent } from './admin-page-content/admin-page-editors/portfolio-upload-editor/portfolio-upload-editor.component';
import { AdminPortfolioUploadButtonComponent } from './admin-page-content/admin-portfolio-upload/admin-portfolio-upload-button.componment';
import { AdminPortfolioUploadService } from './admin-page-content/admin-portfolio-upload/admin-portfolio-upload.service';
import { AdminSystemConfigComponent } from './admin-page-content/admin-system-config/admin-system-config.component';
import { AdminSharedPageComponent } from './admin-page-content/admin-shared-page.component';
import { ETLScheduledJobsEditorComponent } from './admin-page-content/interface-config/etl-scheduled-jobs-editor.component';
import { AdminSharedPageEffects } from '../../redux/effects/admin-page-effects/admin-shared-page.effects';
import { AdminPageButtonComponent } from './admin-page-actions/admin-page-button.component';
import { SEConfigurationEditorComponent } from './admin-page-content/interface-config/se-configuration-edit.component';
import { LocalPythonScriptsEditorComponent } from './admin-page-content/interface-config/local-python-scripts-editor.component';
import { ETLTasksEditorComponent } from './admin-page-content/interface-config/etl-tasks-editor.component';
import { StoreCacheToFileComponent } from './admin-page-content/server-admin/store-cache-to-file.component';
import { StoreCacheToFileWidgetComponent } from './admin-page-content/server-admin/store-cache-to-file-widget.component';
import { PersistentCacheComponent } from './admin-page-content/server-admin/persistent-cache.component';
import { AdminCentralConfigComponent } from './admin-page-content/admin-central-config/admin-central-config.component';
import { ServerMonitoringComponent } from './admin-page-content/server-monitoring/server-monitoring.component';
import { ClamAVFileLookupComponent } from './admin-page-content/server-admin/clamav-file-lookup.component';
import { WebSitesEditorComponent } from './admin-page-content/admin-page-editors/web-sites-editor/web-sites-editor.component';
import { AdminGeneralPageEffects } from '../../redux/effects/admin-page-effects/admin-general-page.effects';
import { GeneralEditorComponent } from './admin-page-content/admin-page-editors/general-editor/general-editor.component';
import { NotificationEditorService } from './admin-page-content/admin-page-editors/notification-editor/notification-editor.service';

@NgModule({
    imports: [
        AgGridModule,
        EffectsModule.forFeature([
            AdminPageGeneralEffects,
            AdminPageNoteTypeEffects,
            AdminPageEntityTypeEffects,
            AdminPageUsersEffects,
            AdminSharedPageEffects,
            AdminGeneralPageEffects
        ]),
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        WidgetsModule,
        TooltipModule,
        InputsModule,
        AaclKeywordSearchModule,
        AaclIconModule.setSvgPath({ svgPath: './assets/tamale.svg#icons-blk_' } as AaclIconModuleOptions),
        DropDownsModule,
        InputsModule,
        DateInputsModule,
        AdminPageRoutingModule,
        MdlDialogModule,
        PopupModule
    ],
    declarations: [
        AdminGeneralComponent,
        AdminPageLayoutComponent,
        AdminPageActionsComponent,
        AdminGridPageComponent,
        AdminPageFilter,
        ContactListFilter,
        UserListFilter,
        AdminAutoTagPageComponent,
        AdminGoogleMapServiceComponent,
        AdminIntralinksComponent,
        AdminWorkflowPageComponent,
        UsersEditorComponent,
        RelationshipsTypesEditorComponent,
        NoteTypesEditorComponent,
        EntityTypesEditorComponent,
        AdminPageWidgetComponent,
        AdminExchangeServerComponent,
        AdminNotificationsComponent,
        AdminPortfolioUploadComponent,
        NotificationEditorComponent,
        PortfolioUploadEditorComponent,
        AdminTemplateSettingsComponent,
        AdminSystemConfigComponent,
        AdminCentralConfigComponent,
        AdminTemplateEditButtonComponent,
        AdminEmailSettingComponent,
        AdminRelationshipsComponent,
        AdminNotificationActiveComponent,
        AdminNotificationActionsComponent,
        AdminPortfolioUploadButtonComponent,
        EditRelationshipDialogComponent,
        AdminPortfolioUploadComponent,
        AdminSharedPageComponent,
        ETLScheduledJobsEditorComponent,
        ETLTasksEditorComponent,
        AdminPageButtonComponent,
        SEConfigurationEditorComponent,
        LocalPythonScriptsEditorComponent,
        StoreCacheToFileComponent,
        StoreCacheToFileWidgetComponent,
        PersistentCacheComponent,
        ServerMonitoringComponent,
        ClamAVFileLookupComponent,
        WebSitesEditorComponent,
        GeneralEditorComponent
    ],
    providers: [
        AdminNotificationActionService,
        EditRelationshipService,
        AdminPortfolioUploadService,
        NotificationEditorService
    ],
    exports: [
        AdminPageLayoutComponent
    ]
})
export class AdminPageLayoutModule { }
